import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  WritableSignal,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  DynamicDialogConfig,
  DynamicDialogRef,
} from '@openng/optimus-ui/dynamicdialog';
import { ProgressSpinnerComponent } from 'src/app/core/components/progress-spinner.component';
import { FacilityApiService } from 'src/app/services/api/facility-api.service';

@Component({
  selector: 'app-facility-qr-code',
  imports: [ProgressSpinnerComponent],
  templateUrl: './facility-qr-code.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './facility-qr-code.component.scss',
})
export class FacilityQrCodeComponent implements OnInit, OnDestroy {
  config = inject(DynamicDialogConfig);
  ref = inject(DynamicDialogRef);
  protected _facilityApi = inject(FacilityApiService);

  readonly loading = signal(true);
  readonly qrCodeUrl: WritableSignal<string | null> = signal(null);

  facilityUid: string = '';

  ngOnInit(): void {
    this.loading.set(true);
    this.facilityUid = this.config?.data?.facilityUid;
    this.loadQRCodeURL(this.facilityUid);
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }

  loadQRCodeURL(facilityUid: string): void {
    this._facilityApi.getFacilityQRCodeURL(facilityUid).subscribe({
      next: (url) => {
        this.qrCodeUrl.set(url);
        this.loading.set(false);
      },
      error: (error) => {
        console.error('Failed to load QR Code URL for this facility!');
        this.loading.set(false);
      },
    });
  }
}
